// extracted by mini-css-extract-plugin
export default {"btn":"btn__h3kb+"};